// extracted by mini-css-extract-plugin
module.exports = {"emptySearch":"emptySearch_emptySearch__bZYoo","emptySearchIcon":"emptySearch_emptySearchIcon__MJDnD","emptySearchDescription":"emptySearch_emptySearchDescription__dD2Df"};